import React from 'react';
import './styles.scss';
import PostcodeSearch from '../PostcodeSearch';
import CourseAutocomplete from '../CourseAutocomplete';
import SchoolSearch from '../SchoolSearch';
import QuestionJump from '../QuestionJump';
import OccupationAutocomplete from '../OccupationAutocomplete';
import Header from '../Header';
import Question from '../Question';
import OccupationSearch from '../OccupationSearch';

const Answer = ({
    currentQuestion,
    type,
    answers,
    storeAnswer,
    removeAnswer,
    selectedAnswer,
    parentAnswerKey,
    subQuestion,
    selectedCourse
}) => {
    const storeSelectedAnswer = (event) => {
        if (selectedCourse && answers[event.target.value].text === 'Yes') {
            storeAnswer(parseInt(event.target.value), {
                text: selectedCourse,
                eligible: true,
                nextQuestion: 3
            }, currentQuestion)
        } else {
            storeAnswer(parseInt(event.target.value), answers[event.target.value], currentQuestion);
        }
    };

    switch (type) {
        case 'radio':
            return Object.entries(answers).map((answer, index) => {
                const name = `currentQuestion${currentQuestion}`;
                const dataSelectedValue =
                    selectedAnswer && parseInt(answer[0]) === selectedAnswer.key ? 'true' : 'false';
                const checked =
                    selectedAnswer && selectedAnswer.hasOwnProperty('key') && index === selectedAnswer.key
                        ? true
                        : false;
                const subQuestionLocal = answer[1].hasOwnProperty('subQuestion') ? answer[1].subQuestion : null;

                return (
                    <div key={index}>
                        <div className='answer-wrapper'>
                            <label data-radio-selected={dataSelectedValue}>
                                <div className='radioLabelInner'>
                                    <input
                                        key={name + 'index'}
                                        name={name}
                                        type='radio'
                                        value={answer[0]}
                                        onClick={storeSelectedAnswer}
                                        defaultChecked={checked}
                                    />
                                    <span>{answer[1].text}</span>
                                </div>
                            </label>
                            <br />
                        </div>
                        {subQuestionLocal && selectedAnswer && selectedAnswer.key === parseInt(answer[0]) && (
                            <>
                                <Header title='' heading={subQuestionLocal.heading} progressStage={3} />
                                <Question
                                    heading={subQuestionLocal.question}
                                    description={subQuestionLocal.description}
                                />
                                <Answer
                                    currentQuestion={currentQuestion}
                                    type='occupation_search'
                                    removeAnswer={removeAnswer}
                                    answers={answers}
                                    storeAnswer={storeAnswer}
                                    selectedAnswer={selectedAnswer}
                                    parentAnswerKey={answer[0]}
                                    subQuestion={true}
                                />
                            </>
                        )}
                    </div>
                );
            });
        case 'select':
            const checked = selectedAnswer && selectedAnswer.hasOwnProperty('key') ? selectedAnswer.key : '';

            return (
                <>
                    <select value={checked} onChange={storeSelectedAnswer}>
                        {Object.entries(answers).map((answer, idx) => (
                            <option key={idx} value={answer[0]}>
                                {answer[1].text}
                            </option>
                        ))}
                    </select>
                </>
            );
        case 'postcode':
            return (
                <PostcodeSearch
                    currentQuestion={currentQuestion}
                    answers={answers}
                    storeAnswers={storeAnswer}
                    selectedAnswer={selectedAnswer}
                    removeAnswer={removeAnswer}
                />
            );
        case 'course':
            return (
                <CourseAutocomplete
                    currentQuestion={currentQuestion}
                    removeAnswer={removeAnswer}
                    storeAnswers={storeAnswer}
                    answers={answers}
                />
            );
        case 'school':
            return (
                <SchoolSearch
                    currentQuestion={currentQuestion}
                    storeAnswers={storeAnswer}
                    removeAnswer={removeAnswer}
                    answers={answers}
                />
            );
        case 'question_jump':
            return <QuestionJump currentQuestion={currentQuestion} storeAnswers={storeAnswer} />;
        case 'occupation_autocomplete':
            return (
                <OccupationAutocomplete
                    currentQuestion={currentQuestion}
                    storeAnswers={storeAnswer}
                    selectedAnswer={selectedAnswer}
                    subQuestion={subQuestion}
                />
            );
        case 'occupation_search':
            return (
                <OccupationSearch
                    currentQuestion={currentQuestion}
                    storeAnswers={storeAnswer}
                    removeAnswer={removeAnswer}
                    selectedAnswer={selectedAnswer}
                    subQuestion={subQuestion}
                />
            );
        default:
            return '';
    }
};

export default Answer;
